import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocalLaundryServiceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"local_laundry_service"}/>
}
